import { z } from "zod";
const DateOnlySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const CrmAttributionQuerySchema = z.object({
    ownerEmail: z.string().email().optional(),
    source: z.string().min(1).max(80).optional(),
    campaign: z.string().min(1).max(120).optional(),
    from: DateOnlySchema.optional(),
    to: DateOnlySchema.optional(),
});
export const CrmAttributionTopDealSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(200),
    status: z.enum(["open", "won", "lost"]),
    amountMinor: z.number().int().nonnegative(),
    weightedAmountMinor: z.number().int().nonnegative(),
});
export const CrmAttributionRowSchema = z.object({
    key: z.string().min(1),
    source: z.string().min(1).max(80),
    campaign: z.string().min(1).max(120).nullable(),
    channel: z.string().min(1).max(80).nullable(),
    contactCount: z.number().int().nonnegative(),
    leadCount: z.number().int().nonnegative(),
    qualifiedLeadCount: z.number().int().nonnegative(),
    dealCount: z.number().int().nonnegative(),
    openDealCount: z.number().int().nonnegative(),
    wonDealCount: z.number().int().nonnegative(),
    lostDealCount: z.number().int().nonnegative(),
    grossPipelineAmountMinor: z.number().int().nonnegative(),
    weightedPipelineAmountMinor: z.number().int().nonnegative(),
    wonAmountMinor: z.number().int().nonnegative(),
    lostAmountMinor: z.number().int().nonnegative(),
    conversionRate: z.number().min(0).max(100),
    latestActivityAt: z.string().datetime().nullable(),
    topDeals: z.array(CrmAttributionTopDealSchema),
});
export const CrmAttributionSummarySchema = z.object({
    sourceCount: z.number().int().nonnegative(),
    contactCount: z.number().int().nonnegative(),
    leadCount: z.number().int().nonnegative(),
    qualifiedLeadCount: z.number().int().nonnegative(),
    dealCount: z.number().int().nonnegative(),
    openDealCount: z.number().int().nonnegative(),
    wonDealCount: z.number().int().nonnegative(),
    grossPipelineAmountMinor: z.number().int().nonnegative(),
    weightedPipelineAmountMinor: z.number().int().nonnegative(),
    wonAmountMinor: z.number().int().nonnegative(),
    conversionRate: z.number().min(0).max(100),
});
export const CrmAttributionReportSchema = z.object({
    generatedAt: z.string().datetime(),
    currency: z.string().length(3),
    filters: CrmAttributionQuerySchema,
    summary: CrmAttributionSummarySchema,
    rows: z.array(CrmAttributionRowSchema),
});
//# sourceMappingURL=crm-attribution.js.map